import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {NBS} from "./nbs";
import {AtividadeNacional} from "./atividade.nacional";

@JacksonType("VinculoNBSAtividadeNacional")
@JsonIdentityInfo()
export class VinculoNBSAtividadeNacional extends SonnerBaseEntity {

  id: number;

  @JacksonType("NBS")
  nbs: NBS;

  @JacksonType("AtividadeNacional")
  atividadeNacional: AtividadeNacional;


}
